/* eslint-disable */
export function initEditProfileForm() {
	const updateBtn = document.getElementById('update-profile-btn');
	if (!updateBtn) return;

	updateBtn.addEventListener('click', async (e) => {
		e.preventDefault();

		const fullNameInput = document.getElementById('full_name');
		const phoneInput = document.getElementById('phone');

		// UI Loading
		updateBtn.disabled = true;
		const originalText = updateBtn.textContent;
		updateBtn.textContent = wpcore.direct_t({ en: 'Updating...', fr: 'Mise à jour...' });

		try {
			const formData = new FormData();
			formData.append('action', 'update_user_profile');
			formData.append('nonce', wpcore.nonce);
			formData.append('full_name', fullNameInput.value);
			formData.append('phone', phoneInput.value);

			const response = await fetch(wpcore.ajaxUrl, {
				method: 'POST',
				body: formData
			});

			const result = await response.json();

			if (result.success) {

				wpcore.closePopup('edit-profile');

				const responseData = result.data;

				if (responseData.updated_data && responseData.updated_data.display_name) {
					const newName = responseData.updated_data.display_name;

					document.querySelectorAll('.js-display-name').forEach(el => {
						el.textContent = newName;
					});

					fullNameInput.value = newName;
				}

				wpcore.showPopup('edit-profile-success');

			} else {
				alert(data.data.message || wpcore.direct_t({ en: 'Error updating profile', fr: 'Erreur lors de la mise à jour du profil' }));
			}

		} catch (error) {
			error;
		} finally {
			updateBtn.disabled = false;
			updateBtn.textContent = originalText;
		}
	});
}
